import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7 14A7 7 0 1 0 7 0a7 7 0 0 0 0 14m.625-9.5a.625.625 0 1 0-1.25 0V7c0 .146.051.288.145.4l2.5 3a.625.625 0 1 0 .96-.8L7.625 6.774z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const interfaceTimeClockCircle = { render };
export {
  interfaceTimeClockCircle as default,
  render
};
//# sourceMappingURL=interface-time-clock-circle.svg.js.map
